// extracted by mini-css-extract-plugin
export default {"List":"Yxs89b6zQjWW9-gCbomIjpmeGK-Z09yVw1zB5zwLvo"};